import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
  selector: "[twoDecimalNumber]",
})
export class TwoDigitDecimaNumberDirective {
  // Allow decimal numbers and negative values
  private readonly regex: RegExp = new RegExp(/^\d*\.?\d{0,2}$/g);
  private readonly regex2: RegExp = new RegExp(/^\d*\,?\d{0,2}$/g);
  // Allow key codes for special events.
  private readonly specialKeys: Array<string> = [
    "Backspace",
    "Tab",
    "End",
    "Home",
    "-",
    "ArrowLeft",
    "ArrowRight",
    "Del",
    "Delete",
  ];

  constructor(private readonly el: ElementRef) {}
  @HostListener("keydown", ["$event"])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [
      current.slice(position),
      event.key == "Decimal" ? "." || "," : event.key,
    ].join("");

    if (next && !String(next).match(this.regex || this.regex2)) {
      event.preventDefault();
    }
  }
}
